import { Stack } from "@mui/material";
import Heading4 from "../typography/heading-04";

const FormSection = ({ title, children, titleClass }) => (
  <>
    <Stack direction="row" sx={{ width: "100%", mt: 3 }}>
      <Heading4
        text={title}
        fontType="semibold"
        extraClass={titleClass}
      />
    </Stack>

    <Stack direction="row" flexWrap="wrap" gap={2}>
      {children}
    </Stack>
  </>
);

export default FormSection;
